import React from 'react';
export const InfrastructureWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-1964">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-1965">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-1966">
          <div className="h-5 w-5 text-orange-500 mr-2" data-id="element-1967" />
          Infrastructure & Transport
        </h2>
      </div>
      <div className="p-6" data-id="element-1968">
        <div className="flex flex-col space-y-4" data-id="element-1969">
          <div className="flex justify-between items-center" data-id="element-1970">
            <span className="text-sm text-gray-600" data-id="element-1971">Road Defect Reports</span>
            <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1972">
              13
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1973">
            <span className="text-sm text-gray-600" data-id="element-1974">Streetlight Outages</span>
            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1975">
              9
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1976">
            <span className="text-sm text-gray-600" data-id="element-1977">
              Parking Permit Applications
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1978">
              16
            </span>
          </div>
          <div className="mt-4 bg-gray-100 rounded-lg p-3" data-id="element-1979">
            <p className="text-xs text-gray-700 font-medium" data-id="element-1980">Active Projects</p>
            <div className="mt-2 text-xs text-gray-600" data-id="element-1981">
              <p data-id="element-1982">• Main St Bridge Repair - 65% Complete</p>
              <p data-id="element-1983">• West Side Sidewalk Expansion</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-200 divide-x divide-gray-200" data-id="element-1984">
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-1985">
          View Maintenance Log
        </a>
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-1986">
          Issue Parking Permits
        </a>
      </div>
    </div>;
};